<template>
  <el-upload
    :key="uploadKey"
    multiple
    name="files"
    accept=".png,.pdf,.jpg,.jpeg,.docx,.doc,.rar,.zip"
    :limit="10"
    :headers="uploadHeaders"
    :action="uploadAction"
    :file-list="fileList"
    :before-upload="handleBeforeUpload"
    :on-exceed="handleExceed"
    :on-success="handleSuccess"
    :on-error="handleUploadError"
    :on-change="handleOnChange"
    :before-remove="handleRemove"
    class="upload"
  >
    <el-button type="primary">点击上传</el-button>
  </el-upload>
</template>

<script>
export default {
  props: {
    isLoading: Boolean,
    fileList: Array
  },

  data() {
    return {
      uploadKey: Math.random(),
      uploadFileList: []
    };
  },

  computed: {
    uploadHeaders() {
      return {
        token: Cookies.get("RequestToken")
      };
    },
    // 上传地址
    uploadAction() {
      return `${process.env.VUE_APP_HOST_API}/COMMON-MODULE-BASE-FILE-PROCESSOR-WEB/api/upload/fildUploadPublicByInputStream?customerId=e6yun3.0&businessTypeKey=contractInfo`;
    },
    // 上传的文件列表
    isUploadLoading() {
      return this.uploadFileList.some(v => v.status === "uploading");
    }
  },

  watch: {
    isUploadLoading(newVal) {
      this.$emit("loadingStatusChange", newVal);
    }
  },

  methods: {
    // 超出数量限制
    handleExceed() {
      this.$message("最多支持上传10个文件");
    },

    // 上传之前的限制
    handleBeforeUpload({ name, size }) {
      const fileTypeReg = /(.png|.pdf|.jpg|.jpeg|.docx|.doc|.rar|.zip)$/;

      if (!fileTypeReg.test(name)) {
        this.$message("上传图片必须是 png/pdf/jpg/jpeg/docx/doc/rar/zip 格式!");
        return false;
      }

      if (size / 1024 / 1024 > 500) {
        this.$message("每个文件最大可上传500M!");
        return false;
      }

      return true;
    },

    // 文件状态改变的钩子
    handleOnChange(file, fileList) {
      this.uploadFileList = fileList;
    },

    // 上传文件成功后的回调
    handleSuccess({ code, result }) {
      if (code === 1 && Array.isArray(result) && result.length) {
        const { fileName, fileUrl } = result[0];
        this.$emit("uploadSuccess", {
          name: fileName,
          url: fileUrl
        });
      } else {
        this.handleUploadError();
      }
    },

    // 上传失败
    handleUploadError() {
      this.reset();
      this.$message("上传失败");
    },

    // 删除文件
    handleRemove(file, fileList) {
      this.$emit("remove", fileList.indexOf(file));
    },

    // 重置
    reset() {
      this.uploadKey = Math.random();
    }
  }
};
</script>
